var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"readOnlyContainer"}},_vm._l((_vm.finalTexts),function(text,id){return _c('span',{key:id},[_vm._v(" "+_vm._s(text)+" "),(_vm.breakOnNewLine)?_c('br'):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }